module.exports = __webpack_public_path__ + "img/1.43a5274d.png";